/**
 * Converts a 24-hour value into it's equivalent 12-hour value.
 * @hidden
 * @param value The 24-hour value.
 * @returns The equivalent 12-hour value.
 */
export const convert24HourTo12Hour = (value) => {
    if (value === 0) {
        return 12;
    }
    else if (value > 12) {
        return value % 12;
    }
    return value;
};
//# sourceMappingURL=convert-24-hour-to-12-hour.js.map